export default Object.freeze({
  CODE_WORD_IS_DISABLED: 'codeWordIsDisabled',
  EDITED_FORMULA: 'editedFormula',
  CONVERTATION_IS_DISABLED: 'convertationIsDisabled',
  PACKAGE_DESCRIPTION_DISABLED: 'packageDescriptionDisabled',
});
